"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const SYMBOLS = __importStar(require("./symbols"));
exports.requiredString = (name) => ({
    type: SYMBOLS.REQUIRED_STRING,
    name,
});
exports.requiredNumber = (name) => ({
    type: SYMBOLS.REQUIRED_NUMBER,
    name,
});
exports.requiredBoolean = (name) => ({
    type: SYMBOLS.REQUIRED_BOOLEAN,
    name,
});
exports.requiredStringArray = (name) => ({
    type: SYMBOLS.REQUIRED_STRING_ARRAY,
    name,
});
exports.requiredNumberArray = (name) => ({
    type: SYMBOLS.REQUIRED_NUMBER_ARRAY,
    name,
});
exports.requiredBooleanArray = (name) => ({
    type: SYMBOLS.REQUIRED_BOOLEAN_ARRAY,
    name,
});
exports.optionalString = (name) => ({
    type: SYMBOLS.OPTIONAL_STRING,
    name,
});
exports.optionalNumber = (name) => ({
    type: SYMBOLS.OPTIONAL_NUMBER,
    name,
});
exports.optionalBoolean = (name) => ({
    type: SYMBOLS.OPTIONAL_BOOLEAN,
    name,
});
exports.optionalStringArray = (name) => ({
    type: SYMBOLS.OPTIONAL_STRING_ARRAY,
    name,
});
exports.optionalNumberArray = (name) => ({
    type: SYMBOLS.OPTIONAL_NUMBER_ARRAY,
    name,
});
exports.optionalBooleanArray = (name) => ({
    type: SYMBOLS.OPTIONAL_BOOLEAN_ARRAY,
    name,
});
//# sourceMappingURL=params.js.map